module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "olst-application"
    }
  }, [_c('virtual-form', {
    attrs: {
      "product-ref": _vm.recipe.product_ref,
      "recipe": _vm.recipe,
      "bundle": _vm.bundle,
      "uom": _vm.uom,
      "version": _vm.version,
      "mint": _vm.mint,
      "debug": _vm.debug,
      "isMobile": _vm.isMobile
    },
    on: {
      "cc-changed": _vm.ccDispatchChanged
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9aa35bfe!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/app/Olst.vue
// module id = 367
// module chunks = 1